/* Grasslands sub-collection nav: move the buffered "empty" (nothing-buyable)
   sub-collection tiles from the top section into the bottom "Out of stock for now"
   block. Rendering them once at the top and relocating here lets the Liquid scan
   each sub-collection's stock a single time (big categories have 100+ of them). */
(function () {
  var section = document.querySelector('[data-gl-empty-section]');
  if (!section) return;
  var target = section.querySelector('[data-gl-empty-target]');
  var source = document.querySelector('[data-gl-empty-source]');

  var tiles = source ? source.children : [];
  if (target && tiles.length) {
    while (source.firstElementChild) {
      target.appendChild(source.firstElementChild);
    }
    section.hidden = false;
  } else {
    // No empties — drop the placeholder block entirely.
    section.remove();
  }
  if (source) source.remove();
})();
